module.exports = __webpack_public_path__ + "img/steamlogin.15f712b2.svg";